import { ImexConfig } from '../types.js'

export const buildImexOptions = (imex: any): ImexConfig | undefined => {
  return imex
}
